export { FingerPrintAlt as default } from './FingerPrintAlt';
